import axios from "axios";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect";
import customModal from "../customModal/customModal.vue";



export default {
    name: 'RaiseQueryPopup',
    components: {
        Multiselect,
        customModal,
        
    },
    props: {
        queryRoute :{
            type: String,
            default: ""
        },
        subjectId:{
            type: String,
            default: ''
        },
        subjectCode: {
            type: String,
            default: ""
        },
        siteId: {
            type: String,
            default: ""
        },
        siteCode : {
            type: String,
            default: ""
        },
        visitName : {
            type: String,
            default: ""
        },
        fieldName :{
            type: String,
            default: ""
        },
        formId : {
            type: String,
            default: ""
        },
        alertId :{
            type: String,
            default: ""
        }
    },
    data() {
        return {
            baseapi: process.env.VUE_APP_Service_URL,
            values: {
                QueryFor_Id :"",
                studyId: "",
                siteId: "",
                siteCode: "",
                subjectId: "",
                visitName: "",
                fieldName: "",
                formName: "",
                querySubject: "",
                queryMessage: "",
                sender: "",
                priority: "Low",
                recipients: [],
                pageNo: 0,
                pageName: "",
                queryFor: "",
            },
            errors: [false, false, false, false],
            chksendmail: "",
            showField: true,
            checkboxclick: false,
            emailrecipients: [],
            selectedRoles: [],
            roleList: [],
            formData: {},
            formID: "",
            recipients :[],
            userName: "",
            passstudyname :"",
            subject:{},
            payLoad: {},
            selectedemailrecipients : [],
        }
    },
    async mounted() {
        this.formID = this.formId;
        console.log("RaiseQueryPopup mounted");
        this.bindData();
        this.setRoleList();
        this.getUserName();
    },
    methods: {
        async closeQueryModal() {
            this.$emit("closeModal");
        },
        async bindData(){
            await this.GetFormData();
            await this.getStudyname();
            await this.getPatient(this.formData.subjectId); 
            this.values.siteId = this.siteId;
            this.values.siteCode = this.siteCode;    
            this.values.subjectId = this.subjectCode;
            this.values.fieldName = this.fieldName;
            this.values.formName = this.formData.formName;
            this.values.visitName = this.formData.visitName;
            this.values.studyId = this.formData.studyId;
            if(this.queryRoute == "Sdv"){
                this.values.studyId = await store.getters.getStudyIs;
            }
            this.values.QueryFor_Id = this.alertId;
            if(this.queryRoute == "Alert"){
                this.values.queryFor = "Alert";
            }
            if(this.queryRoute == "Sdv"){
                this.values.queryFor = "SDV";
            }
            console.log("Bind Data values is : ", this.values);
        },
        async GetFormData() {
            const idtoken = store.getters.getIdToken;
            await axios
                .get(`${this.baseapi}/forms/forms/getbyid/` + this.formID, {
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                },
                })
                .then((res) => {
                this.formData = res.data;
                })
                .catch((err) => {
                console.log(err);
                });
        },
        async setRoleList() {
                const idtoken = store.getters.getIdToken;
                await axios
                  .get(`${this.baseapi}/account-core/roles/rolelist`, {
                    headers: {
                      Authorization: "Bearer " + idtoken,
                      "Content-Type": "application/json",
                    },
                  })
                  .then((res) => {
                    this.roleList = res.data;
                  });
        },
        async createQuery(){
            await this.validateIsNull();
            if ( !this.errors[0] &&!this.errors[1] &&!this.errors[2] && !this.errors[3] ) {
                await this.getselectedemailrecepients();
                await this.setPayLoad();

                const idtoken = store.getters.getIdToken;
                await axios.post(`${this.baseapi}/forms/query/create`, this.payLoad, {
                    headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "application/json",
                    },
                    })
                    .then((res) => {
                        console.log("create Query ");
                        alert("Query Created Successfully");
                        if(this.queryRoute !== "Sdv")
                        {
                            this.$emit("queryRaised")
                        }                       
                        this.closeQueryModal();
                    })
                    .catch((err) => {
                        console.log("error in creating query",err);
                    });
            }  
        },
        async ClearData() {
            this.values.querySubject = "";
            this.values.queryMessage = "";
            this.values.priority = "";
            this.values.selectedRoles = [];
            this.values.recipients = [];
        },
        async check(){
              if(this.checkboxclick)
              { 
                this.checkboxclick =false;
                this.emailrecipients = [];
              }else{  
                  this.checkboxclick =true;
                  this.emailrecipients = [];
                  this.values.recipients.forEach((element) => {
                    let eusers = {
                      id: String,
                      evalu: String,
                      isChecked: Boolean,
                    };
                  
                      eusers.evalu = element;
                      eusers.isChecked=true;
                      this.emailrecipients.push(eusers);  
                  });
              } 
        },
        async onroleClosed() {
            if (Array.isArray(this.emailrecipients)) this.emailrecipients.splice(0);
            if (Array.isArray(this.recipients)) this.recipients.splice(0);
            if (this.values && Array.isArray(this.values.recipients)) this.values.recipients.splice(0);
            await this.getrolebasedrecepients();
        },
        async closebtnclicked() {
            if (Array.isArray(this.emailrecipients)) this.emailrecipients.splice(0);
            if (Array.isArray(this.recipients)) this.recipients.splice(0);
            if (this.values && Array.isArray(this.values.recipients)) this.values.recipients.splice(0);
            await this.getrolebasedrecepients();
        },
        async getrolebasedrecepients() {
            console.log("In get role based recipients");
            const valnow = await store.getters.getStudyIs;
            const idtoken = store.getters.getIdToken;
            var rcount = this.selectedRoles.length;
            if (rcount > 0) {
                var fullroleids = "";
                for (var i = 0; i < rcount; i++) {
                fullroleids = fullroleids + this.selectedRoles[i] + ",";
                }
                console.log("formdata", this.formData.siteId);
                await axios
                .get(`${this.baseapi}/account-core/user/getusersbyrole?roleids=` +
                             fullroleids +`&studyid=` +valnow +`&siteId=` + this.formData.siteId,
                    {
                    headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "application/json",
                    },
                    }
                )
                .then((res) => {
                    this.recipients = [];
                    res.data.forEach((element) => {
                        if (element.email != this.userName)
                            { this.recipients.push(element); }
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
            } else { this.recipients = []; }
        },
        async onRecipientsClosed() {
          if (Array.isArray(this.selectedemailrecipients)) { this.selectedemailrecipients.splice(0);}
            this.values.recipients.forEach((recipient) => {
                const exists = this.emailrecipients.find((emailRecipient) => emailRecipient.evalu === recipient);
                if (!exists) {
                let eusers = {
                    id: String,
                    evalu: String,
                    isChecked: Boolean,
                };
                eusers.evalu = recipient;
                eusers.isChecked=true;
                this.emailrecipients.push(eusers);
                }
            });
            this.emailrecipients.forEach((emailRecipient) => {
                const exists = this.values.recipients.find((recipient) => emailRecipient.evalu === recipient);
                if (!exists) {
                const index = this.emailrecipients.indexOf(emailRecipient);
                this.emailrecipients.splice(index,1);
                }
            });
        },
        async recepientclosebtnclicked() {
            console.log("RECP CLOSED", this.multiRoleSelectList);
            this.emailrecipients.splice(0);
        },
        async validateIsNull() {
            if (this.values.querySubject == "") {
                this.errors[0] = true;
            } else {
                this.errors[0] = false;
            }

            if (this.values.queryMessage == "") {
                this.errors[1] = true;
            } else {
                this.errors[1] = false;
            }

            if (this.values.recipients == "") {
                this.errors[2] = true;
            } else {
                this.errors[2] = false;
            }

            if (this.selectedRoles.length === 0) {
            this.errors[3] = true;
            } else {
            this.errors[3] = false;
            }
        },
        async getselectedemailrecepients() {
            if (this.checkboxclick == true) {
                this.emailrecipients.forEach((element) => {
                    console.log("emailrecipients", element);
                if (element.isChecked) {
                    this.selectedemailrecipients.push(element.evalu);
                }
                });
            } else {
                console.log("Unchecked!");
            }
            console.log("selectedemailrecipients", this.selectedemailrecipients);
        },
        async  getUserName() {
            const idToken = store.getters.getIdToken;
            const jwtDecodedValue = await this.jwtDecrypt(idToken);
            this.userName = jwtDecodedValue.name;
        },
        async getStudyname() {
            const studyname = store.getters.getStudyIs;
            const idtoken = store.getters.getIdToken;
            await axios
                .get(
                `${this.baseapi}/management/study/getbyid?id=${studyname}&api-version=1.0`,
                {
                    headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                    },
                }
                )
                .then((res) => {
                this.passstudyname = res.data.studyName;
                })
                .catch((err) => {
                console.log(err);
                });
        },
        async getPatient(patientId) {
            const idtoken = store.getters.getIdToken;
            await axios
                .get(`${this.baseapi}/management/patient/getpatientbyid/` + patientId, {
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                },
                })
                .then((res) => (this.subject = res.data))
                .catch((err) => console.log(err));
        },
        async jwtDecrypt(token) {
            const base64Url = token.split(".")[1];
            const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
            const jsonPayload = decodeURIComponent(
                atob(base64)
                .split("")
                .map(function (c) {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
            );
            return JSON.parse(jsonPayload);
        },
        async setPayLoad(){
            this.payLoad = {
                queryId: "",
                formId: this.formID,
                studyId: this.values.studyId,
                folderId: this.formData.folderId,
                siteId:  this.formData.siteId,
                subjectId: this.formData.subjectId,
                visitId:  this.formData.visitId,
                visitName:  this.formData.visitName,
                queryFor:  this.values.queryFor,
                queryFor_Id: this.alertId,
                query_Subject: this.values.querySubject,
                priority: this.values.priority,
                pageNo: 0,
                fieldName:  this.values.fieldName,
                queryOpenStatus: "true",
                queryResponseStatus: true,
                closeBy: "",
                formName: this.values.formName,
                messages: [
                    {
                    queryMessage: this.values.queryMessage,
                    raisedBy: this.userName,
                    raisedByName: "",
                    raisedDate: new Date().toISOString(),
                    messagesRecipients: [
                        { recipients: this.values.recipients }
                    ]
                    }
                ],
                emailRecepients: this.selectedemailrecipients,
                sitecode: this.values.siteCode,
                pagename: "",
                patientid: this.subject.subjectId,
                studyname: this.passstudyname,
                 queryOrigin: "Manual"
            };
            console.log("Payload is : ", this.payLoad);
        }
    }
}